module.exports = __webpack_public_path__ + "static/media/image.5a68fdb1.png";